import { Toggle } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import type { UseFormMethods } from 'react-hook-form'
import styled from 'styled-components'

import * as Styled from './styled'

export interface DispensingOptionInPracticeProps {
  className?: string
  control: UseFormMethods['control']
}

const StyledToggle = styled(Toggle)`
  max-width: 350px;
  && {
    input:checked + label .slider {
      // royal blue 500 with 58% opacity
      background-color: #3259e296;
    }
    label > span {
      display: flex;
      align-items: center;
      // increase width
      flex: 1;
    }
  }
`

const DispensingOptionInPractice: FC<DispensingOptionInPracticeProps> = ({
  className,
  control,
}) => {
  return (
    <div>
      <h3 className="small-h3">In-Practice dispensary</h3>
      <Styled.Description>
        As a fully licensed practitioner, purchase products directly for your practice.
      </Styled.Description>
      <StyledToggle
        className={className}
        name="inPractice"
        control={control}
        defaultChecked={true}
        preventChange
        disabled
      >
        <Styled.Label>In-Practice dispensing</Styled.Label>
      </StyledToggle>
    </div>
  )
}

export default DispensingOptionInPractice
